import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { Switch } from "./Switch";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorSwitchPropertyValues =
    PropertyEditorPropertyValues
    & {
    };

export type PropertyEditorSwitchProperties = {
    [name in keyof PropertyEditorSwitchPropertyValues]: Property<PropertyEditorSwitchPropertyValues[name]>
};

export interface IPropertyEditorSwitch extends IPropertyEditor, PropertyEditorSwitchProperties
{
}

export class PropertyEditorSwitch extends PropertyEditor implements IPropertyEditorSwitch
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorSwitch";
    public static override className = "PropertyEditorSwitch";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorSwitchPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new Switch(),
            }
        };
    }

    // #endregion

    // #endregion
}

